module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/6_8265459cd4a4b8a9ee18db143c3822f4.png";